import { Link, NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import AuthUtility from '../frontend/auth/AuthUtility';
import { useAudio } from '../../context/AudioProvider';

import romergence_square_image from '../../assets/frontend/images/romergence_square.png';
import liked_songs_square_image from '../../assets/frontend/images/liked_songs_square.png';
import to_infinity_square_image from '../../assets/frontend/images/to_infinity_square.png';
import fragments_of_the_mind_square_image from '../../assets/frontend/images/fragments_of_the_mind_square.png';
import fragments_of_the_mind_square_lighter_image from '../../assets/frontend/images/fragments_of_the_mind_square_lighter.png';
import to_infinity_and_back_square_image from '../../assets/frontend/images/to_infinity_and_back_square.png';
import rise_and_fall_square_image from '../../assets/frontend/images/rise_and_fall_square.png';
import between_the_moment_square_image from '../../assets/frontend/images/between_the_moment_square.png';
import age_of_ascension_square_image from '../../assets/frontend/images/age_of_ascension_square.png';
import through_the_concrete_square_image from '../../assets/frontend/images/through_the_concrete_square.png';

const LIKE_KEY = 'romergence_liked_tracks';

const AlbumsPanel = ({ onClose, track, tracklist }) => {

  const navHistory = useNavigate();
  // using hooks
  const [hasLikedTracks, setHasLikkedTracks] = useState(false);

  const { likedMap } = useAudio();

  const safeLikedMap = likedMap || [];

  useEffect(() => {

    const likedTracksArray =
      Array.isArray(safeLikedMap.tracks)
        ? safeLikedMap.tracks
        : []; // normalize
    if (likedTracksArray.length > 0) {
      setHasLikkedTracks(true);
    }
  }, [safeLikedMap]);

  function handleAlbum(title_private, type) {
    if (!title_private || title_private === '' || !type || type === '') {
      return;
    }
    if (AuthUtility.isLoggedIn()) {
      navHistory('/member/album/' + title_private + '/' + type);
    } else {
      //user not authenticated on server so remove from local storage
      AuthUtility.clearAuthData();
      navHistory('/album/' + title_private + '/' + type);
    }
    onClose();
  }

  return (
    <div className="options-content">
      <div className="panel large p-20l-10s">
        <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">
          <span className="center-everything">
            <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">Albums & Playlists</span>
          </span>
          <span className="align-right">
            <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
          </span>
        </div>

        <div className="grid-x">

          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('to_infinity', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    To Infinity
                  </div>
                </div>
              </div>
              <img src={to_infinity_square_image} className="b1-555 hide-for-small-only" alt="to_infinity image" width="100%" />
              <img src={to_infinity_square_image} className="b1-555 show-for-small-only" alt="to_infinity image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('to_infinity', 'album')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m pl-0l-5m" onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Framents Of
                    <div className='pt-10l-5m'></div>
                    The Mind
                  </div>
                </div>
              </div>
              <img src={fragments_of_the_mind_square_lighter_image} className="b1-555 hide-for-small-only" alt="fragments_of_the_mind image" width="100%" />
              <img src={fragments_of_the_mind_square_lighter_image} className="b1-555 show-for-small-only" alt="fragments_of_the_mind image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    To Infinity
                    <div className='pt-10l-5m'></div>
                    & Back
                  </div>
                </div>
              </div>
              <img src={to_infinity_and_back_square_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={to_infinity_and_back_square_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m" onClick={() => handleAlbum('age_of_ascension', 'demos')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Age Of
                    <div className="pt-10l-5m"></div>
                    Ascension
                  </div>
                </div>
              </div>
              <img src={age_of_ascension_square_image} className="b1-555 hide-for-small-only" alt="age_of_ascension image" width="100%" />
              <img src={age_of_ascension_square_image} className="b1-555 show-for-small-only" alt="age_of_ascension image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('age_of_ascension', 'demos')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m" onClick={() => handleAlbum('rise_and_fall', 'demos')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Rise & Fall
                  </div>
                </div>
              </div>
              <img src={rise_and_fall_square_image} className="b1-555 hide-for-small-only" alt="rise_and_fall image" width="100%" />
              <img src={rise_and_fall_square_image} className="b1-555 show-for-small-only" alt="rise_and_fall image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('rise_and_fall', 'demos')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m" onClick={() => handleAlbum('between_the_moment', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Between The
                    <div className="pt-10l-5m"></div>
                    Moment
                  </div>
                </div>
              </div>
              <img src={between_the_moment_square_image} className="b1-555 hide-for-small-only" alt="between_the_moment image" width="100%" />
              <img src={between_the_moment_square_image} className="b1-555 show-for-small-only" alt="between_the_moment image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('between_the_moment', 'album')}>
                Listen
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m" onClick={() => handleAlbum('through_the_concrete', 'demos')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Through The
                    <div className="pt-10l-5m"></div>
                    Concrete
                  </div>
                </div>
              </div>
              <img src={through_the_concrete_square_image} className="b1-555 hide-for-small-only" alt="through_the_concrete image" width="100%" />
              <img src={through_the_concrete_square_image} className="b1-555 show-for-small-only" alt="through_the_concrete image" width="100%" />
            </div>
            <div className="pt-5 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('through_the_concrete', 'demos')}>
                Listen
              </button>
            </div>
          </div>
          {hasLikedTracks && (
            <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('liked_songs_demos', 'liked')}>
              <div className="text-overlay-wrapper text-center">
                <div className="text-overlay-1020-bottom50">
                  <div className="position-align-bottom pb-10 text-center">
                    <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                      Liked Songs
                      <div className='pt-10l-5m'></div>
                      & Demos
                    </div>
                  </div>
                </div>
                <img src={liked_songs_square_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
                <img src={liked_songs_square_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
              </div>
              <div className="pt-5 text-center">
                <button className="button small width-80pxl-70pxm-80pxs plr-20"
                  onClick={() => handleAlbum('liked_songs_demos', 'liked')}>
                  Listen
                </button>
              </div>
            </div>
          )}
          {localStorage.getItem('user_playlist') && (
            <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum(localStorage.getItem('user_playlist'), 'playlist')}>
              <div className="text-overlay-wrapper text-center">
                <div className="text-overlay-1020-bottom50">
                  <div className="position-align-bottom pb-10 text-center">
                    <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                      Your Playlist
                    </div>
                  </div>
                </div>
                <img src={romergence_square_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
                <img src={romergence_square_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
              </div>
              <div className="pt-5 text-center">
                <button className="button small width-80pxl-70pxm-80pxs plr-20"
                  onClick={() => handleAlbum(localStorage.getItem('user_playlist'), 'playlist')}>
                  Listen
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
          <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
        </div>
      </div>
    </div>
  );
};

export default AlbumsPanel;
